import { render } from "./siteperformance.vue?vue&type=template&id=430320f4&scoped=true"
import script from "./siteperformance.js?vue&type=script&lang=js"
export * from "./siteperformance.js?vue&type=script&lang=js"

import "./siteperformance.vue?vue&type=style&index=0&id=430320f4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-430320f4"]])

export default __exports__